<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_29142_284984)">
      <path d="M4.88916 3.55534H3.11138M4.88916 5.77698H3.11138M7.11138 0.888672L2.46941 0.888672C1.59666 0.888672 0.88916 1.59617 0.88916 2.46892V13.5306C0.88916 14.4034 1.59666 15.1109 2.46941 15.1109H7.11138M7.11138 0.888672H8.00027L13.5311 0.888672C14.4039 0.888672 15.1114 1.59617 15.1114 2.46892V13.5306C15.1114 14.4034 14.4039 15.1109 13.5311 15.1109H7.11138M7.11138 0.888672V15.1109M4.88916 7.99978H3.11138" stroke="currentColor" stroke-width="1.28" stroke-linecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_29142_284984">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">

</script>
